var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.391,
    height: 58,
    viewBox: "0 0 40.391 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Component_6_12",
    "data-name": "Component 6 \\u2013 12",
    transform: "rotate(180 19.945 29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Union_3",
    fill: "rgba(0,0,0,0)",
    stroke: "#000000d9",
    strokeWidth: "3px",
    d: "M9.687 9.5L0 0l9.687 9.5.313-.306-.313.306.313.306-.313-.306L0 19z",
    "data-name": "Union 3",
    transform: "translate(28.061 18.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_90",
    fill: "none",
    stroke: "rgba(46,45,121,0.17)",
    d: "M0 0L0 58",
    "data-name": "Line 90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGallery);
export default __webpack_public_path__ + "static/media/arrow-gallery.d91ef84f9b5fcec0f8553d7184e8479c.svg";
export { ForwardRef as ReactComponent };